import { render, staticRenderFns } from "./AdsGroupSetting.vue?vue&type=template&id=4a345eb6"
import script from "./AdsGroupSetting.vue?vue&type=script&lang=js"
export * from "./AdsGroupSetting.vue?vue&type=script&lang=js"
import style0 from "./AdsGroupSetting.vue?vue&type=style&index=0&id=4a345eb6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports